import {
  ConnectionStatus,
  IncidentType,
  PROJECT_STATE,
  SYSTEM_PROJECT_TYPE,
} from "util/CommonConstant";
import { BE_TRAINING_STATE, CONNECTION_SYNC_STATE } from "util/DataSourceConstant";
import DatasourceModel from "./Datasource.model";
import { UserModel } from "./User.model";
import { IContextFile } from "interface/common";
import InstructionModel from "./Instruction.model";

export default class ProjectModel {
  description: string | null;
  instructions: string | null;
  projectInstructions: InstructionModel | null;
  iconStyle: string | null;
  name: string | null;
  uuid: string | null;
  dataSourceCount?: number | null;
  connections?: DatasourceModel[];
  team?: UserModel[];
  connectionStatus: ConnectionStatus | null;
  trainingState?: BE_TRAINING_STATE | null;
  syncState?: CONNECTION_SYNC_STATE | null;
  projectState: PROJECT_STATE | null;
  statusMessage?: string | null;
  ready?: boolean;
  autoResponderOptions?: Record<string, any> | null;
  systemProjectType?: SYSTEM_PROJECT_TYPE;
  readyToUploadFiles?: boolean = false;
  incidentTypes?: IncidentType[] | null;
  telemetryStates?: {
    [key: string]: {
      state: PROJECT_STATE | null;
      connections: DatasourceModel[] | [];
    };
  };
  projectContextFiles: IContextFile[] = [];

  constructor(
    uuid: string | null = null,
    description: string | null = null,
    instructions: string | null = null,
    projectInstructions: InstructionModel | null = null,
    iconStyle: string | null = null,
    name: string | null = null,
    dataSourceCount: number | null = null,
    connections: DatasourceModel[] = [],
    team: UserModel[] = [],
    connectionStatus: ConnectionStatus | null = null,
    projectState: PROJECT_STATE | null = null,
    trainingState: BE_TRAINING_STATE | null = null,
    statusMessage: CONNECTION_SYNC_STATE | null = null,
    ready = false,
    autoResponderOptions: Record<string, any> | null = null,
    systemProjectType: SYSTEM_PROJECT_TYPE = SYSTEM_PROJECT_TYPE.UNSPECIFIED,
    incidentTypes: IncidentType[] | null = null,
    telemetryStates: {
      [key: string]: {
        state: PROJECT_STATE | null;
        connections: DatasourceModel[] | [];
      };
    } = {}
  ) {
    this.description = description;
    this.instructions = instructions;
    this.projectInstructions = projectInstructions;
    this.iconStyle = iconStyle;
    this.name = name;
    this.uuid = uuid;
    this.dataSourceCount = dataSourceCount;
    this.connections = connections;
    this.team = team;
    this.connectionStatus = connectionStatus;
    this.projectState = projectState;
    this.trainingState = trainingState;
    this.statusMessage = statusMessage;
    this.ready = ready;
    this.autoResponderOptions = autoResponderOptions;
    this.systemProjectType = systemProjectType;
    this.telemetryStates = telemetryStates;
    this.incidentTypes = incidentTypes;
  }
}
